import * as $ from 'jquery';
import { BoxesCommon } from './boxes-common';

export class BoxesFrontend {
    static init() {

        $(document).ready(() => {
            BoxesCommon.heightFix();
            BoxesCommon.resizeFix();
            BoxesCommon.spaceFixes();

        })
    }
}
        
